import users from './modules/users'
import Vuex from 'vuex'
import Vue from 'vue'
import profile from './modules/profile'
import notifications from './modules/notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
      profile,
      users,
      notifications
  }
})
